class ProductTabCarousel extends HTMLElement {
  constructor() {
    super();
    this.activeSlideIndex = 0;
    this.slidesPerView = 4; // Default for desktop
    this.slidesPerViewMobile = 1.66; // Default for mobile
    this.currentSlidesPerView = this.slidesPerView;
    this.startX = 0;
    this.scrollLeft = 0;
  }

  connectedCallback() {
    this.container = this.querySelector('.carousel');
    this.nextButton = this.querySelector('.next-button');
    this.prevButton = this.querySelector('.prev-button');
    this.slidesContainer = this.querySelector('.slides');
    this.slides = Array.from(this.querySelectorAll('.slides .slide'));
    this.slide = this.querySelector('.slides .slide');
    this.allInteractiveElements = this.querySelectorAll('.slides a, .slides button');

    if (this.nextButton) {
      this.nextButton.addEventListener('click', () => this.nextSlide());
    }

    if (this.prevButton) {
      this.prevButton.addEventListener('click', () => this.prevSlide());
    }

    this.initMediaQueryListener();
    this.hideNonVisibleSlides();
    this.updateNavButtons();
  }

  initMediaQueryListener() {
    this.mediaQuery = window.matchMedia('(max-width: 768px)');
    this.mediaQuery.addEventListener('change', this.updateSlidesPerView.bind(this));
    this.updateSlidesPerView();
  }

  updateSlidesPerView() {
    if (this.mediaQuery.matches) {
      this.currentSlidesPerView = this.slidesPerViewMobile;
    } else {
      this.currentSlidesPerView = this.slidesPerView;
    }
  }

  nextSlide() {
    const maxIndex = this.slides.length - Math.ceil(this.currentSlidesPerView);
    if (this.activeSlideIndex < maxIndex) {
      this.goToSlide(this.activeSlideIndex + 1);
    }
    this.updateNavButtons();
  }

  prevSlide() {
    if (this.activeSlideIndex > 0) {
      this.goToSlide(this.activeSlideIndex - 1);
    }
    this.updateNavButtons();
  }

  goToSlide(nextSlideIndex) {
    const slideWidth = this.slide.getBoundingClientRect().width;
    this.slidesContainer.scrollTo({ left: slideWidth * nextSlideIndex, behavior: 'smooth' });
    this.updateSlideVisibility(nextSlideIndex);
    this.activeSlideIndex = nextSlideIndex;
  }

  hideNonVisibleSlides() {
    this.slides.forEach((slide) => slide.setAttribute('aria-hidden', 'true'));
    this.allInteractiveElements.forEach((el) => el.setAttribute('tabindex', '-1'));

    for (let i = 0; i < Math.ceil(this.currentSlidesPerView); i++) {
      const visibleSlideIndex = this.activeSlideIndex + i;
      if (this.slides[visibleSlideIndex]) {
        this.slides[visibleSlideIndex].removeAttribute('aria-hidden');
        this.slides[visibleSlideIndex].querySelectorAll('a, button').forEach((el) => el.removeAttribute('tabindex'));
      }
    }
  }

  updateSlideVisibility(nextSlideIndex) {
    this.activeSlideIndex = nextSlideIndex;
    this.hideNonVisibleSlides();
  }

  resetCarousel() {
    this.goToSlide(0);
  }

  updateNavButtons() {
    const maxIndex = this.slides.length - Math.ceil(this.currentSlidesPerView);

    if (this.prevButton == null || this.nextButton == null) {
      return;
    }

    if (this.prevButton) {
      if (this.activeSlideIndex === 0) {
        this.prevButton.classList.add('opacity-50');
        this.prevButton.style.cursor = 'default';
      } else {
        this.prevButton.classList.remove('opacity-50');
        this.prevButton.style.cursor = 'pointer';
      }
    }

    if (this.nextButton) {
      if (this.activeSlideIndex >= maxIndex) {
        this.nextButton.classList.add('opacity-50');
        this.nextButton.style.cursor = 'default';
      } else {
        this.nextButton.classList.remove('opacity-50');
        this.nextButton.style.cursor = 'pointer';
      }
    }
  }
}

customElements.define('product-tab-carousel', ProductTabCarousel);
